import React, { useState, useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import { dashboardRoutes, endpointsFromRoutes } from "../config/dashboardRoutes";
import styles from "./DashboardLayout.module.css";

export default function DashboardLayout({ title = "Data management" }) {
    const { pathname } = useLocation();
    const endpoints = endpointsFromRoutes(dashboardRoutes);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // Close mobile drawer on route change
    useEffect(() => {
        setIsDrawerOpen(false);
    }, [pathname]);

    return (
        <div className={styles.frame}>
            {/* Desktop/Tablet sidebar */}
            <aside className={styles.sidebar} aria-label={title}>
                <Sidebar
                    title={title}
                    endpoints={endpoints}
                    activePath={pathname}
                    LinkComponent={Link}
                />
            </aside>

            {/* Mobile drawer (overlays header; high z-index) */}
            <div
                className={`${styles.drawerBackdrop} ${isDrawerOpen ? styles.open : ""}`}
                onClick={() => setIsDrawerOpen(false)}
            />
            <aside
                className={`${styles.drawer} ${isDrawerOpen ? styles.open : ""}`}
                aria-label={title}
                role="dialog"
                aria-modal="true"
            >
                <Sidebar
                    title={title}
                    endpoints={endpoints}
                    activePath={pathname}
                    LinkComponent={Link}
                    onRequestClose={() => setIsDrawerOpen(false)}
                />
            </aside>

            {/* Main content */}
            <section className={styles.body}>
                <div className={styles.bodyHeader}>
                    {/* Mobile-only menu button */}
                    <button
                        type="button"
                        className={`${styles.iconBtn} ${styles.mobileOnly}`}
                        aria-label="Open menu"
                        onClick={() => setIsDrawerOpen(true)}
                    >
                        <span className={styles.iconBurger} />
                    </button>
                </div>
                <Outlet />
            </section>
        </div>
    );
}
